module.exports = __webpack_public_path__ + "img/1.3318b36f.jpeg";